'use strict'

/**
 * Project janux-vuejs-seed
 * Created by hielo on 2018-05-14
 */
import {Person} from 'janux-people'
import _ from 'lodash'

export function userService (http, partyService) {
	return {
		// Find users by specifying the field and search string
		findBy: function (field, search) {
			return http.jsonrpc(
				'/rpc/2.0/users',
				'findBy',
				[ field, search ]
			).then((resp) => {
				let out = resp.result
				out = (typeof out.length === 'undefined') ? [out] : out
				console.log('findBy', field, search, out)
				out.forEach((user, iUser) => {
					out[iUser].contact = Person.fromJSON(out[iUser].contact)
				})
				return out
			})
		},

		// Load users by its account activity in a given period of time
		findByAccountActivity: function (period) {
			return http.jsonrpc(
				'/rpc/2.0/users',
				'findByAccountActivity',
				[ period ]
			).then((resp) => {
				let out = resp.result
				out.forEach((user, iUser) => {
					out[iUser].contact = Person.fromJSON(out[iUser].contact)
				})
				return out
			})
		},

		// Load user by id
		findById: function (userId) {
			return http.jsonrpc(
				'/rpc/2.0/users',
				'findById',
				[ userId ]
			).then((resp) => {
				let out = resp.result
				const id = out.contact.id
				out.contact = Person.fromJSON(out.contact)
				out.contact.id = id
				return out
			})
		},

		// Load all users by user id
		findByUsernameMatch: function (username) {
			return http.jsonrpc(
				'/rpc/2.0/users',
				'findByUsernameMatch',
				[ username ]
			).then((resp) => {
				let out = resp.result
				out.forEach((user, iUser) => {
					out[iUser].contact = Person.fromJSON(out[iUser].contact)
				})
				return out
			})
		},

		// Add new user
		saveOrUpdate: function (userObject) {
			let userObjClone = _.cloneDeep(userObject)
			const id = userObjClone.contact.id
			const typeName = userObjClone.contact.typeName
			userObjClone.contact = userObjClone.contact.toJSON()
			userObjClone.contact.id = id
			userObjClone.contact.typeName = typeName

			// //
			// // If the user's role has been loaded, we ensure that only the name is stored back
			// //
			// userObjClone.roles = _.map(userObjClone.roles, function (role) {
			//	return (typeof role.name !== 'undefined')?role.name:role
			// })

			return http.jsonrpc(
				'/rpc/2.0/users',
				'saveOrUpdate',
				[ userObjClone ]
			).then((resp) => {
				const out = resp.result
				console.log('saveOrUpdate', out)
				return out
			}).catch((err) => {
				// A failed save arrives as an HTTP 500 whose body carries the
				// server's validation errors (e.g. {attribute: 'contact.emails',
				// message: 'There is another record with the same email
				// address'}). Reject with the first of those, as
				// user-action-service's insert does, so callers can tell the
				// user why instead of the failure vanishing.
				// A refusal that is not a validation list (e.g. a wrong old
				// password) arrives as a single {code, message} object instead.
				const serverErrors = err && err.body && err.body.error
				if (_.isArray(serverErrors) && serverErrors.length > 0) {
					throw serverErrors[0]
				}
				if (_.isPlainObject(serverErrors) && serverErrors.message) {
					throw serverErrors
				}
				throw err
			})
		},

		findOneByUsernameOrEmail: (subject) => {
			return http.jsonrpc(
				'/rpc/public/userAction',
				'findOneByUsernameOrEmail',
				[ subject ]
			).then((resp) => {
				console.log('user found', resp)
				let out = resp.result
				const id = out.contact.id
				out.contact = partyService.fromJSON(out.contact)
				out.contact.id = id
				return out
			}).catch((err) => {
				if (!_.isNil(err.data)) {
					console.error('findOneByUsernameOrEmail Error' + err.data.error.message)
				} else {
					console.error('findOneByUsernameOrEmail Error' + err)
				}
				return null
			})
		},

		// Delete user by id
		deleteUser: function (userId) {
			return http.jsonrpc(
				'/rpc/2.0/users',
				'deleteUser',
				[ userId ]
			).then((resp) => {
				return resp.result
			})
		}
	}
}



// WEBPACK FOOTER //
// ./src/common/services/user-service.js